import { Injectable } from '@angular/core';
import { StorageAdapter } from '../../../domain/adapters/storage.adapter';

@Injectable()
export class LocalStorageService implements StorageAdapter {
  constructor() {}

  set<Value>(key: string, value: Value): void {
    localStorage.setItem(key, value as string);
  }
  get<Value>(key: string): Promise<Value> {
    return Promise.resolve(localStorage.getItem(key) as Value);
  }
  getBlocking<Value>(key: string): Value {
    return localStorage.getItem(key) as Value;
  }
  remove(key: string): void {
    localStorage.removeItem(key);
  }
  removeAll(): void {
    localStorage.clear();
  }
}
